export default __webpack_public_path__ + "static/media/skills-dark.99ea21b5.svg";